import type { ReactNode } from 'react'

export type HeadlineLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

const SECTION_HEADLINE_LEVELS: Record<HeadlineLevel, HeadlineLevel> = {
	h1: 'h2',
	h2: 'h2',
	h3: 'h3',
	h4: 'h3',
	h5: 'h3',
	h6: 'h3',
}

export const getSectionHeadlineLevel = (level?: HeadlineLevel | null): HeadlineLevel => {
	if (!level) {
		return 'h2'
	}

	return SECTION_HEADLINE_LEVELS[level] ?? 'h2'
}

export const Headline = ({
	children,
	className,
	level = 'h2',
}: { level?: HeadlineLevel; children: ReactNode; className?: string }) => {
	switch (level) {
		case 'h1':
			return <h1 className={className}>{children}</h1>
		case 'h2':
			return <h2 className={className}>{children}</h2>
		case 'h3':
			return <h3 className={className}>{children}</h3>
		case 'h4':
			return <h4 className={className}>{children}</h4>
		case 'h5':
			return <h5 className={className}>{children}</h5>
		case 'h6':
			return <h6 className={className}>{children}</h6>
	}
}
